import type { Lang } from '@platform/core/types';
import type { IMyWorkWireItem } from '@platform/dao';
import type { IRecordTypeLabels } from '@platform/features/search/IRecordTypeLabels';

/**
 * Підпис пріоритету рядка «Моєї роботи» мовою інтерфейсу (чиста функція): варіант каталогу priorityKey — підпис із визначення його модуля
 * (для типів без поля пріоритету — варіант «Завдань», як словник прототипу: «Середній»); доки визначення вантажиться чи сервер старіший —
 * підпис сервера мовою інтерфейсу, далі власний варіант типу, інакше значення як є.
 */
export function priorityText(item: IMyWorkWireItem, lang: Lang, keyed: IRecordTypeLabels, own: IRecordTypeLabels): string {
  const key = item.priorityKey;
  const fromKey = key ? keyed.option(key.field, key.value) : '';
  if (key && fromKey && fromKey !== key.value) return fromKey;
  return item.priorityLabel?.[lang] || fromKey || own.option('priority', item.priority);
}
